import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  createStyles,
  makeStyles
} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import SignatureCanvas from 'react-signature-canvas';
import {DEFAULT_BACKGROUND_COLOR} from 'src/style/variable';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';

interface AddSignatureModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateSign: (signURL: string) => void;
  signCanvasClassName?: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    signatureDialogTitle: {
      paddingBottom: '0.5rem'
    },
    signCanvas: {
      width: '100%',
      height: '15rem',
      backgroundColor: DEFAULT_BACKGROUND_COLOR
    },
    signatureDialogActionButton: {
      '& .MuiButton-label': {
        // fontSize: '1rem'
      }
    },
    signPadActionButtonWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '0.5rem'
    },
    signatureDialogActionWrapper: {
      flexWrap: 'wrap-reverse',
      justifyContent: 'center',
      gap: '0.5rem'
    }
  })
);

const AddSignatureModal = ({
  isOpen,
  onClose,
  onCreateSign,
  signCanvasClassName
}: AddSignatureModalProps): JSX.Element => {
  const {t} = useTranslation();
  const sigCanvas = useRef<any>();
  const classes = useStyles();
  const {enqueueSnackbar} = useSnackbar();

  const createSignHandler = () => {
    if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
      const URL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
      onCreateSign(URL);
      onClose();
    } else {
      enqueueSnackbar(
        t(
          'APPOINTMENTS_SCHEDULAR_PORTAL.SCHEDULE_APPOINTMENT.SIGNATURE_CANNOT_BE_BLANK'
        ),
        SnackBarConfig('e')
      );
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle disableTypography className={classes.signatureDialogTitle}>
        <p>{t('APPOINTMENTS_SCHEDULAR_PORTAL.DRAW_YOUR_SIGNATURE_BELOW')}</p>
      </DialogTitle>
      <DialogContent>
        <SignatureCanvas
          penColor="black"
          ref={sigCanvas}
          canvasProps={{
            className: `${classes.signCanvas} ${signCanvasClassName}`
          }}
        />
        <Divider />
        <div className={classes.signPadActionButtonWrapper}>
          <Button onClick={() => sigCanvas?.current?.clear()}>
            {t('COMMON.CLEAR')}
          </Button>
        </div>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.signatureDialogActionWrapper}>
        <Button
          // className={classes.cancelButton}
          onClick={onClose}
          className={classes.signatureDialogActionButton}>
          {t('DUE_INVOICES.NOTIFICATION_DIALOG.BUTTON_CANCEL')}
        </Button>
        <Button
          // className={classes.deleteClinicButton}
          onClick={createSignHandler}
          variant="contained"
          color="primary"
          className={classes.signatureDialogActionButton}>
          {t('APPOINTMENTS_SCHEDULAR_PORTAL.SUBMIT_SIGNATURE')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSignatureModal;
